    /* ==========================================================================
   header-custom.js
   Goes with: sections/header.liquid (header-custom.css + header-custom.js)
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var searchToggleBtn = header.querySelector('.site-header__icon--search');
  var searchBar = header.querySelector('.site-header__search-bar');
  var searchInput = searchBar ? searchBar.querySelector('input[type="search"]') : null;

  var mobileToggleBtn = header.querySelector('.mobile-nav-toggle');
  var drawer = header.querySelector('.mobile-nav-drawer');
  var drawerCloseBtn = header.querySelector('.mobile-nav-drawer__close');
  var overlay = header.querySelector('.mobile-nav-overlay');
  var expandBtns = header.querySelectorAll('.mobile-nav-drawer__expand');

  /* ---------------- Search bar toggle ---------------- */
  function toggleSearch(forceState) {
    if (!searchBar) return;
    var isOpen = searchBar.classList.contains('is-open');
    var open = typeof forceState === 'boolean' ? forceState : !isOpen;

    searchBar.classList.toggle('is-open', open);
    searchBar.hidden = false; // let max-height animation handle visibility

    if (open && searchInput) {
      setTimeout(function () {
        searchInput.focus();
      }, 150);
    }
  }

  if (searchToggleBtn) {
    searchToggleBtn.addEventListener('click', function () {
      toggleSearch();
    });
  }

  /* ---------------- Mobile drawer open/close ---------------- */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    if (mobileToggleBtn) mobileToggleBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    if (mobileToggleBtn) mobileToggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';

    setTimeout(function () {
      if (overlay && !overlay.classList.contains('is-open')) {
        overlay.hidden = true;
      }
    }, 300);
  }

  if (mobileToggleBtn) {
    mobileToggleBtn.addEventListener('click', function () {
      var isOpen = drawer && drawer.classList.contains('is-open');
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  if (drawerCloseBtn) {
    drawerCloseBtn.addEventListener('click', closeDrawer);
  }

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  /* ---------------- Mobile submenu expand/collapse ---------------- */
  expandBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('.mobile-nav-drawer__link-row');
      var li = btn.closest('li');
      var submenu = li ? li.querySelector('.mobile-nav-drawer__submenu') : null;
      if (!submenu) return;

      var isOpen = !submenu.hidden;
      submenu.hidden = isOpen;
      btn.classList.toggle('is-open', !isOpen);
      btn.textContent = isOpen ? '+' : '\u2212'; // '+' closed, '−' open
    });
  });

  /* ---------------- Escape key closes drawer / search ---------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    if (searchBar && searchBar.classList.contains('is-open')) toggleSearch(false);
  });

  /* ---------------- Desktop dropdown: keyboard/touch support ---------------- */
  var dropdownItems = header.querySelectorAll('.site-header__menu-item.has-dropdown');
  dropdownItems.forEach(function (item) {
    var link = item.querySelector(':scope > a');
    if (!link) return;

    link.addEventListener('click', function (e) {
      // On touch devices, first tap opens the dropdown instead of following the link
      if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
        e.preventDefault();
        dropdownItems.forEach(function (other) {
          other.classList.remove('is-open');
        });
        item.classList.add('is-open');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) {
      dropdownItems.forEach(function (item) {
        item.classList.remove('is-open');
      });
    }
  });
});

    
